import SimpleSchema from '@boilerplate/lib/simpleSchema';
import { getI18n } from 'react-i18next';

const schema = new SimpleSchema({
        id: {
          type: String,
          optional: true,
          form: false,
          view: true,
        },
        name: {
          type: String,
          form: true,
          view: true,
        },
        addToNewProjects: {
          type: Boolean,
          defaultValue: false,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        loggedHours: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'loggedHour',
            displayField: 'id',
          },
          optional: true,
          form: false,
          view: true,
        },
        'loggedHours.$': {
          type: String,
          optional: true,
        },
        projects: {
          type: Array,
          relation: {
            name: 'BelongsToMany',
            type: 'ManyToMany',
            model: 'project',
            displayField: 'name',
          },
          optional: true,
          form: true,
          view: true,
        },
        'projects.$': {
          type: String,
          optional: true,
        },
        hasHours: {
          type: Boolean,
          defaultValue: true,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        hasInvoices: {
          type: Boolean,
          defaultValue: true,
          form: {
            component: 'Boolean',
          },
          view: true,
        },
        parentCategory: {
          type: String,
          relation: {
            name: 'ManyToOne',
            type: 'ManyToOne',
            model: 'category',
            displayField: 'name',
          },
          optional: true,
          form: true,
          view: true,
        },
        subCategories: {
          type: Array,
          relation: {
            name: 'OneToMany',
            type: 'OneToMany',
            model: 'category',
            displayField: 'name',
          },
          optional: true,
          form: false,
          view: true,
        },
        'subCategories.$': {
          type: String,
          optional: true,
        },
        tenant: {
          type: String,
          relation: {
            name: 'ManyToOne',
            type: 'ManyToOne',
            model: 'tenant',
            displayField: 'name',
          },
          form: true,
          view: true,
        },
        createdAt: {
          type: Date,
          optional: true,
          form: false,
          view: true,
        },
        updatedAt: {
          type: Date,
          optional: true,
          form: false,
          view: true,
        },
        deletedAt: {
          type: Date,
          optional: true,
          form: false,
          view: true,
        },
});

const { t } = getI18n();
schema.labels({
        id: t(['entityFields:category.id', 'entityFields:default.id'], '') || undefined,
        name: t(['entityFields:category.name', 'entityFields:default.name'], '') || undefined,
        addToNewProjects: t(['entityFields:category.add_to_new_projects', 'entityFields:default.add_to_new_projects'], '') || undefined,
        loggedHours: t(['entityFields:category.logged_hour', 'entityFields:default.logged_hour'], '') || undefined,
        projects: t(['entityFields:category.project', 'entityFields:default.project'], '') || undefined,
        hasHours: t(['entityFields:category.has_hours', 'entityFields:default.has_hours'], '') || undefined,
        hasInvoices: t(['entityFields:category.has_invoices', 'entityFields:default.has_invoices'], '') || undefined,
        parentCategory: t(['entityFields:category.parent_category', 'entityFields:default.parent_category'], '') || undefined,
        subCategories: t(['entityFields:category.sub_categories', 'entityFields:default.sub_categories'], '') || undefined,
        tenant: t(['entityFields:category.tenant', 'entityFields:default.tenant'], '') || undefined,
        createdAt: t(['entityFields:category.created_at', 'entityFields:default.created_at'], '') || undefined,
        updatedAt: t(['entityFields:category.updated_at', 'entityFields:default.updated_at'], '') || undefined,
        deletedAt: t(['entityFields:category.deleted_at', 'entityFields:default.deleted_at'], '') || undefined,
});

export default schema;